module.exports = __webpack_public_path__ + "static/media/Original Korean - Teaching - Prayer of penitence and prayer of hope.96d2226d.txt";